'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.App_13cf0331 = void 0;
var _react = require('react');
const App_13cf0331 = exports.App_13cf0331 = /*#__PURE__*/(0, _react.createContext)({
  _$_appMessage: ""
});
